Vue.component('ack-events', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-events',
	mixins: [languageMixins],
	created() {},
	mounted() {
		appLog.log('ack-events mounted');
		this.setPageIsLoading(false);
	},
	props: {
		// dataIn: {
		//   type: Object,
		//   required: true
		// }
	},
	computed: {
		//...Vuex.mapGetters('sliders', ['slidersLists']),
		//...Vuex.mapGetters('articles', ['articlesArray']),
		isMobile() {
			return this.$parent.isMobile;
		},
	},
	data() {
		return {
			pageId: 'events-page',
			events: [
				{
					date: 'Mar, 2025',
					title: 'CDA, Cambodia dental Association',
					location: 'Cambodia',
					booth: '-',
					represented: 'Medtronicam Trading Co.,Ltd.',
				},
				{
					date: 'Mar 25-29, 2025',
					title: 'IDS',
					location: 'Cologne Germany',
					booth: 'Booth H-71',
					represented: 'Atomica.ai & Ackuretta',
				},
				{
					date: 'Mar 30 - Apr 1, 2025',
					title: 'The 47th Science and Technology Conference',
					location: 'Ho Chi Minh City',
					booth: '-',
					represented: 'Dentistry Of Excellence (D.O.E)',
				},
				{
					date: 'Apr 10-12, 2025',
					title: 'KRAKDENT',
					location: 'Poland',
					booth: '-',
					represented: '',
				},
				{
					date: 'May 1-4, 2025',
					title: 'Borneo Dental Congress',
					location: 'Kota Kinabalu, Sabah.',
					booth: '-',
					represented: '',
				},
				{
					date: 'May 12-16, 2025',
					title: 'Philippine Dental Association Convention',
					location: 'Philippines',
					booth: '-',
					represented: 'Frontier Dental',
				},
				{
					date: 'May 15-17, 2025',
					title: 'KONAS PDGI 2025',
					location: '',
					booth: '-',
					represented: '',
				},
				{
					date: 'May 30-31, 2025',
					title: 'International Dental Congress Masters',
					location: 'Kyiv',
					booth: '-',
					represented: 'InSpe',
				},
				{
					date: 'July 22, 2025',
					title: '8th Malaysia International Dental Show',
					location: 'Sunway Pyramid Convention Centre, Selangor.',
					booth: '-',
					represented: 'Medes (M) Sdn Bhd',
				},
				{
					date: 'Sept 4-6, 2025',
					title: 'Warsaw Dental Medica Show',
					location: 'Poland',
					booth: '-',
					represented: '3D Phoenix Dental',
				},
				{
					date: '',
					title: 'Malaysian Dental Technologist Conference',
					location: '',
					booth: '-',
					represented: '',
				},
			],
		};
	},
	methods: {
		...Vuex.mapActions(['setPageIsLoading']),
		//...Vuex.mapActions('sliders', ['getSlideList'])
		sortEventsOldest() {
			this.events.sort((a, b) => {
				const aDate = new Date(this.formatDate(a.date));
				const bDate = new Date(this.formatDate(b.date));
				return aDate - bDate;
			});
		},
		sortEventsLatest() {
			this.events.sort((a, b) => {
				const aDate = new Date(this.formatDate(a.date));
				const bDate = new Date(this.formatDate(b.date));
				return bDate - aDate;
			});
		},
		formatDate(date) {
			const dateArray = date.split(',');
			const firstDate = dateArray[0].split('-')[0];
			const year = dateArray[1];
			return firstDate + year;
		},
	},
	beforeDestroy() {},
	watch: {
		data1: {
			handler() {},
			deep: false,
		},
	},
});
